module.exports = __webpack_public_path__ + "img/icon_3.e4a6bab5.png";